<form [formGroup]="form">
  <div class="py-2 text-sm font-semibold">
    {{ 'meter.information' | translate }}
  </div>
  <app-input-group>
    <label appLabel>{{ 'meter.commissioningDate' | translate }}</label>
    <input type="date" appInputDate formControlName="commissioningDate" [attr.readonly]="currentMeterdto">
  </app-input-group>

  <app-input-group>
    <label appLabel>{{ 'meter.meterNumber' | translate }}</label>
    <input
      appInput
      formControlName="meterNumber"
      (focusout)="updateMeterValue(form.get('meterNumber')?.value)"
      placeholder="{{ 'meter.createform.meterId' | translate }}"
    >
  </app-input-group>

  <app-input-group>
    <label appLabel>{{ 'meter.alternativeMeterNumber' | translate }}</label>
    <input
      appInput
      formControlName="alternateMeterNumber"
      (focusout)="updateMeterValue(form.get('alternateMeterNumber')?.value)"
      placeholder="{{ 'meter.alternativeMeterNumber' | translate }}"
    >
  </app-input-group>

  <app-input-group>
    <label appLabel>{{ 'meter.serialNumber' | translate }}</label>
    <input
      appInput
      formControlName="serialNumber"
      (focusout)="updateMeterValue(form.get('serialNumber')?.value)"
      placeholder="{{ 'meter.serialNumber' | translate }}"
    >
  </app-input-group>

  <div class="py-2 text-sm font-semibold">
    {{ 'meter.product' | translate }}
  </div>
  <fieldset formGroupName="vendor">
    <app-input-group>
      <label appLabel>{{ 'vendor.name' | translate }}</label>
      <select appSelect formControlName="name">
        <option value="">{{ 'meterFrame.form.chooseGeneric' | translate }}</option>
        @for (vendor of vendors; track vendor.id) {
          <option [value]="vendor.name">{{ vendor.name }}</option>
        }
      </select>
    </app-input-group>
  </fieldset>
  <fieldset formGroupName="model">
    <app-input-group>
      <label appLabel>{{ 'model.name' | translate }}</label>
      <select appSelect formControlName="name">
        <option value="">{{ 'meterFrame.form.chooseGeneric' | translate }}</option>
        @for (model of meterModels; track model.id) {
          <option [value]="model.name">{{ model.name }}</option>
        }
      </select>
    </app-input-group>
  </fieldset>

  <app-input-group>
    <label appLabel>{{ 'model.productionYear' | translate }}</label>
    <input appInput formControlName="productionYear" placeholder="{{ 'model.productionYear' | translate }}">
  </app-input-group>

  <app-input-group>
    <label appLabel>{{ 'model.numberOfDigits' | translate }}</label>
    <input appInputFixedDigits formControlName="numberOfDigits" placeholder="{{ 'model.numberOfDigits' | translate }}">
  </app-input-group>

  <app-input-group>
    <label appLabel>{{ 'model.readingType' | translate }}</label>
    <select appSelect formControlName="meterReadingType">
      <option value="" disabled>{{ 'meterFrame.form.chooseGeneric' | translate }}</option>
      <option value="Accumulated">{{ 'meterreadingtype.accumulated' | translate }}</option>
      <option value="Balanced">{{ 'meterreadingtype.balanced' | translate }}</option>
    </select>
  </app-input-group>

  <!-- Omregninsfaktor -->
  <div class="py-2 text-sm font-semibold">
    {{ 'meterFrame.conversionFactor' | translate }}
  </div>

  <app-input-group>
    <label appLabel>A14</label>
    <input appInput formControlName="conversionFactorA14" min="0.0001" required step="any" type="number">
  </app-input-group>

  <app-input-group>
    <label appLabel>A23</label>
    <input appInput formControlName="conversionFactorA23" min="0.0001" required step="any" type="number">
  </app-input-group>

  <app-input-group>
    <label appLabel>R12</label>
    <input appInput formControlName="conversionFactorR12" min="0.0001" required step="any" type="number">
  </app-input-group>

  <app-input-group>
    <label appLabel>R34</label>
    <input appInput formControlName="conversionFactorR34" min="0.0001" required step="any" type="number">
  </app-input-group>

  <app-input-group>
    <label appLabel>{{ 'meter.acquisitionDate' | translate }}</label>
    <input type="date" appInput formControlName="acquisitionDate">
  </app-input-group>

  <app-input-group>
    <label appLabel>{{ 'meter.accuracyClass' | translate }}</label>
    <select appSelect [collection]="accuracyClassList" formControlName="accuracyClass"></select>
  </app-input-group>

  <app-input-group>
    <label appLabel>{{ 'meter.measurementPrinciple' | translate }}</label>
    <select appSelect [collection]="measurementPrincipleList" formControlName="measurementPrinciple"></select>
  </app-input-group>

  <app-input-group>
    <label appLabel>{{ 'meter.comment' | translate }}</label>
    <input appInput formControlName="comment" placeholder="{{ 'meter.comment' | translate }}">
  </app-input-group>

  <app-input-group>
    <label appLabel>{{ 'meter.ctTurnOverRatio' | translate }}</label>
    <select appSelect [collection]="ctTurnOverRatioList" formControlName="ctTurnOverRatio"></select>
  </app-input-group>

  <app-input-group>
    <label appLabel>{{ 'meter.vtTurnOverRatio' | translate }}</label>
    <select appSelect [collection]="vtTurnOverRatioList" formControlName="vtTurnOverRatio"></select>
  </app-input-group>

  @if (currentMeterdto?.verificationMeter) {
    <app-input-group>
      <label appLabel>{{ 'meteringpoint.meter.createcontrolmeter.relativedeviation' | translate }}</label>
      <input appInput type="number" formControlName="relativeDeviation"
             append="%">
    </app-input-group>

    <app-input-group>
      <label appLabel>{{ 'meteringpoint.meter.createcontrolmeter.absolutedeviation' | translate }}</label>
      <input appInput type="number" formControlName="absoluteDeviation"
             append="kW">
    </app-input-group>
  }

  @if (currentMeterdto) {
    <div class="py-2 text-sm font-semibold">
      {{ 'meter.quadrant' | translate }}
    </div>
    <app-input-group>
      <label appLabel>A14</label>
      <select appSelect [collection]="quadrant" formControlName="mappingA14"></select>
    </app-input-group>
    <app-input-group>
      <label appLabel>A23</label>
      <select appSelect [collection]="quadrant" formControlName="mappingA23"></select>
    </app-input-group>
    <app-input-group>
      <label appLabel>R12</label>
      <select appSelect [collection]="quadrant" formControlName="mappingR12"></select>
    </app-input-group>
    <app-input-group>
      <label appLabel>R34</label>
      <select appSelect [collection]="quadrant" formControlName="mappingR34"></select>
    </app-input-group>
  }
</form>
